var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" Dodaj nowy oddział ")]),_c('v-card-text',[_c('CompanyBranchAddEdit',{attrs:{"companyId":this.companyId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }